import React from "react";
import "./styles.css";

interface AgradecimentoMirimProps {
  onClose?: () => void;
}

const AgradecimentoMirim: React.FC<AgradecimentoMirimProps> = ({ onClose }) => {

  const handleClose = () => {
    window.location.href = "/clube-pai-eterno";
  };

  return (
    <div className="clube-overlay">
      <div
        className="clube-modal"
        style={{
          backgroundImage: `url(${'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/fundo-clube.png'})`,
        }}
      >


        <div className="clube-content">

        <div className="clube-header">
    <img
      src={'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/logo-modal.png'}
      alt="Clube do Pai Eterno"
      className="clube-logo"
    />
  </div>

          {/* BLOCO 1 */}
          <div className="clube-info">

            <div className="clube-text">
              <p>

                <strong>
                Cadastro realizado com carinho! 💗              </strong>
              </p>
            </div>
          </div>

          {/* BLOCO 2 */}
          <div className="clube-info">




            <div className="clube-text">
              <p>
              Recebemos o cadastro com muito carinho e agradecemos por permitir que o{" "}
                <strong>
                Clube do Pai Eterno
                </strong>{" "}
                faça parte da caminhada de fé da sua família.
              </p>
            </div>
          </div>

          {/* BLOCO 3 */}
          <div className="clube-info">


            <div className="clube-text">
              <p>
              Que essa caminhada seja repleta de bênçãos e que, a cada dia, o coração de nossas crianças floresça cercado pelo amor de Deus e pelo carinho de sua família.

              </p>
            </div>
          </div>

          {/* BLOCO 4 */}
          <div className="clube-info clube-last-info">

            <div className="clube-text">
              <strong>
              Seja muito bem-vindo ao Clube do Pai Eterno!
              </strong>
            </div>


          </div>

          <div className="clube-info">




            <div className="clube-text">
              <p>
              Que o {" "}

                <strong>
               Divino Pai Eterno
                </strong>{" "}
                 abençoe, proteja sempre. 🙏💙
              </p>
            </div>
          </div>

          <button  className="clube-button" onClick={handleClose}>

            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgradecimentoMirim;
